<template>
  <div>
    <b-row class="h750 chartarea">
      <b-col class="col-5 pr10">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">누적 데이터 현황</h6>
          <ag-grid-vue
            class="ag-theme-balham totDataStatGrid"
            :gridOptions="totStatGridOptions"
          ></ag-grid-vue>
        </b-card>
      </b-col>
      <b-col class="col-7 pl10">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header" class="jcfe">
            데이터 현황
            <div class="searchBox h40 jcfe" style="margin-left: 250px">
              <div>
                <b-form-input
                  type="date"
                  v-model="stdate"
                  style="padding-left: 8px; padding-right: 5px; width: 147px"
                ></b-form-input>
                <label>~</label>
                <b-form-input
                  type="date"
                  v-model="eddate"
                  style="padding-left: 8px; padding-right: 5px; width: 147px"
                ></b-form-input>
                <b-button
                  class="searchBtn"
                  style="margin-top: 0px"
                  @click="getData"
                  >조회</b-button
                >
              </div>
            </div>
          </h6>
          <b-row
            v-for="(item, idx) in weekChart"
            :key="idx"
            :class="'hc-div' + weekChart.length"
          >
            <b-col class="py0">
              <div
                :id="'datatypeLineChart' + (idx + 1)"
                class="graph default-border-top1"
              ></div>
            </b-col>
          </b-row>
          <!-- <b-row class="h-50">
            <b-col class="py0">
              <div id="dataSizeLineChart" class="graph default-border-top1"></div>
            </b-col>
          </b-row>
          <b-row class="h-50">
            <b-col class="py0">
              <div id="dataCntLineChart" class="graph default-border-top1"></div>
            </b-col>
          </b-row> -->
        </b-card>
      </b-col>
    </b-row>
    <div class="btnGrp">
      <div class="jcfe pr20">
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import chartUtil from "../common/chartUtil";
import utils from "../common/utils";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters(["getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      totStatGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      dataChart1: {
        x: [],
        y: [],
      },
      weekChart: [],
      stdate: null,
      eddate: null,
    };
  },
  created() {
    this.stdate = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.eddate = moment().format("YYYY-MM-DD");
  },
  beforeMount() {
    this.totStatGridOptions.columnDefs = [
      { headerName: "디바이스 ID", field: "deviceid", hide: true },
      { headerName: "데이터 타입", field: "datatype", width: 120 },
      { headerName: "데이터 크기(MB)", field: "datasize", width: 120 },
      { headerName: "데이터 개수", field: "datacnt", width: 100 },
    ];
  },
  mounted() {
    this.getData();
  },
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    // 센서 데이터 조회
    getData() {
      var reqBody = {
        deviceid: this.defaultInfo.devid,
        stdate: this.stdate,
        eddate: this.eddate,
      };
      this.$http
        .post("/sensor/getSensorDataStats", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var chartData = res.data.data;
            let totStat = chartData.totalStat;
            let weekStat = chartData.weekStat;
            let rowData = [];
            for (let i = 0; i < totStat.length; i++) {
              rowData.push({
                deviceid: totStat[i].deviceid,
                datatype: totStat[i].datatype,
                datasize: Number(totStat[i].totaldatasize).toFixed(4),
                datacnt: Number(totStat[i].totaldatacnt).toLocaleString(
                  "ko-KR"
                ),
              });
            }
            this.totStatGridOptions.api.setRowData(rowData);
            // 일주일 데이터 차트 셋팅
            for (let i = 0; i < weekStat.length; i++) {
              let j = 0;
              for (j = 0; j < this.weekChart.length; j++) {
                if (this.weekChart[j].title === weekStat[i].datatype) break;
              }
              if (j < this.weekChart.length) {
                this.weekChart[j].time.push(weekStat[i].collecttime);
                this.weekChart[j].size.push(weekStat[i].totaldatasize);
                this.weekChart[j].cnt.push(weekStat[i].totaldatacnt);
              } else {
                this.weekChart.push({
                  title: weekStat[i].datatype,
                  time: [weekStat[i].collecttime],
                  size: [weekStat[i].totaldatasize],
                  cnt: [weekStat[i].totaldatacnt],
                });
              }
            }
            this.$nextTick(() => {
              for (let i = 0; i < this.weekChart.length; i++) {
                // 데이터 사이즈 셋팅
                this.drawDualAxisLineChart("datatypeLineChart" + (i + 1), {
                  data: {
                    x: this.weekChart[i].time,
                    y1: this.weekChart[i].size,
                    name1: "Data Size",
                    y2: this.weekChart[i].cnt,
                    name2: "Data Count",
                  },
                  annotation: {
                    xaxis: {
                      text: this.weekChart[i].title,
                      x: 0.5,
                      y: 1.16,
                    },
                    yaxis: {
                      text: "Data Size(MB)",
                      x: -0.1,
                      y: 0.5,
                    },
                    yaxis2: {
                      text: "Data Count",
                      x: 1.1,
                      y: 0.5,
                    },
                  },
                });
              }
            });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawLineChart(id, options) {
      var data = [];
      for (let i = 0; i < options.data.length; i++) {
        data.push({
          x: options.data[i].x,
          y: options.data[i].y,
          name: options.data[i].name,
          type: "scatter",
          mode: "lines+markers",
          line: { width: 1 },
        });
      }
      var layout = chartUtil.setTimeLayout(id, {
        annotation: options.annotation,
        margin: {
          l:
            utils.chkNull(options.annotation) !== null &&
            utils.chkNull(options.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 20,
          t: 0,
          b: 0,
          pad: 0,
        },
        showlegend: false,
      });
      layout.xaxis.tickformat = "%Y-%m-%d";
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    // x축이 시간이면서 Y축이 좌우인 라인 차트 그리기
    drawDualAxisLineChart(id, options) {
      var data = [
        {
          x: options.data.x,
          y: options.data.y1,
          name: options.data.name1,
          type: "scatter",
          mode: "lines+markers",
          line: { width: 1 },
        },
        {
          x: options.data.x,
          y: options.data.y2,
          name: options.data.name2,
          type: "scatter",
          mode: "lines+markers",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setDualAxisDateLayout(id, {
        annotation: options.annotation,
        showlegend: true,
        margin: {
          l:
            utils.chkNull(options.annotation) !== null &&
            utils.chkNull(options.annotation.yaxis) !== null
              ? 80
              : 50,
          r:
            utils.chkNull(options.annotation) !== null &&
            utils.chkNull(options.annotation.yaxis2) !== null
              ? 80
              : 50,
          t:
            utils.chkNull(options.annotation) !== null &&
            utils.chkNull(options.annotation.xaxis) !== null
              ? 40
              : 20,
          b: 30,
          pad: 0,
        },
        legend: {
          orientation: "h",
          x: 0.4,
          y: -0.15,
          font: {
            color: "#e2e2e2",
          },
        },
      });
      Plotly.newPlot(id, data, layout);
    },
    closeModal() {
      this.$bvModal.hide("sensorDataStatChartModal");
    },
  },
};
</script>

<style lang="scss">
#sensorDataStatChartModal .modal-dialog {
  max-width: 1500px;
  & .chartarea {
    padding: 20px;
    & .card {
      padding: 0;
      & .card-header {
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          width: 100%;
          height: 100%;
        }
      }
    }
    & div.ag-theme-balham.totDataStatGrid {
      height: calc(100% - 60px) !important;
      & .ag-root .ag-body .ag-body-viewport {
        overflow-x: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDataStatChartModal.vue